
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["longtermUserModify_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M156.038 341.333h711.924V512h97.524V58.514H58.514v906.972H512v-97.524H156.038V341.333zm711.924-185.295v87.772H156.038v-87.772h711.924z"}}),_c('path',{attrs:{"d":"M741.181 512c-121.905 0-224.305 97.524-224.305 224.305S614.4 960.61 741.181 960.61s224.305-97.524 224.305-224.305S867.962 512 741.18 512zm0 365.714c-78.02 0-146.286-63.39-146.286-146.285 0-78.02 63.39-146.286 146.286-146.286 78.019 0 146.286 63.39 146.286 146.286s-63.39 146.285-146.286 146.285z"}}),_c('path',{attrs:{"d":"M765.562 633.905h-78.02v156.038h175.544v-78.02h-97.524z"}})])
          )
        }
      }
    